import React from "react";
import "./Section.scss";

interface SectionProps {
  id?: string;
  className?: string;
  children: JSX.Element | Array<JSX.Element>;
}

export const Section: React.FC<SectionProps> = (props: SectionProps) => {
  const componentName = "page-section";
  const { id, className, children } = props;

  return (
    <section
      id={`${id ? id : null}`}
      className={`${className ? `${componentName} ${className}` : componentName}`}
    >
      {children}
    </section>
  );
};
